import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/standard-button';
import PipelinesIcon from '@atlaskit/icon/glyph/bitbucket/pipelines';
import Tooltip from '@atlaskit/tooltip';

import { RunPipelineContext } from 'src/components/pipelines/pages/modals/run-pipeline-modal';
import { useIntl } from 'src/hooks/intl';
import { ConnectedExpander } from 'src/sections/repository/sections/pull-request/components/connected-expander';

import messages from './confirm-modal.i18n';
import { RunPipelineButtonText } from './styles';

export type Props = {
  branchName: string;
  branchHash: string;
  isCollapsed?: boolean;
};

const BRANCH_LOCALSTORAGE_KEY = 'branch.pipelines.card.collapsed';

export const RunPipelineModalFromBranch = ({
  branchName,
  branchHash,
  isCollapsed = false,
}: Props): JSX.Element => {
  const intl = useIntl();

  const labels = {
    rich: <FormattedMessage {...messages.pipelineToolbox} />,
    plain: intl.formatMessage(messages.pipelineToolbox),
  };

  if (isCollapsed) {
    return (
      <Tooltip position="left" content={labels.plain}>
        <Button
          appearance="subtle"
          iconBefore={
            <PipelinesIcon size="medium" label="pipelines-sidecard" />
          }
        />
      </Tooltip>
    );
  }

  return (
    <ConnectedExpander
      localStorageKey={BRANCH_LOCALSTORAGE_KEY}
      icon={<PipelinesIcon size="medium" label="pipelines-sidecard-icon" />}
      dataTestId="branch-pipelines-toolbox"
      label={labels.rich}
      sectionAriaLabel={intl.formatMessage(messages.actionRunPipeline)}
      headingAriaLabel={intl.formatMessage(messages.actionRunPipeline)}
    >
      <RunPipelineContext.Consumer>
        {({ open }) => (
          <Button
            appearance="link"
            onClick={() =>
              open({
                refName: branchName,
                revision: branchHash,
              })
            }
            spacing="none"
          >
            <RunPipelineButtonText>
              <FormattedMessage {...messages.actionRunPipeline} />
            </RunPipelineButtonText>
          </Button>
        )}
      </RunPipelineContext.Consumer>
    </ConnectedExpander>
  );
};
